import { useEffect } from 'react';
import { useUpdate } from '@bydesign-ui/hooks';
import { useUpload } from './useUpload';
export function useFileUpdate(id) {
  var fileUpload = useUpload();
  var update = useUpdate();
  useEffect(function () {
    var fileChange = function fileChange(changeId) {
      id === changeId && update();
    };

    var destroy = function destroy() {
      fileUpload.removeListener('file-change', fileChange);
    };

    fileUpload.addListener('file-change', fileChange);
    return destroy;
  }, []);
}